import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import React from "react";
import ShippingDeadlineCalculator from "../ShippingDeadlineColumn/ShippingDeadlineCalculator";
import OrderDTO from "@/dto/order/OrderDTO";
import { showDeadlineShippingOrderTabs } from "@/utils/OrderTabUtil";

interface PickupDeadlineWarningInfoProps {
    shop: ShopDTO;
    order: OrderDTO;
    tab: OrderTab;
}

const pickupDeadlineWarningShopTypes = [ShopType.PINDUODUO, ShopType.PDD_FDS];

export function shouldRenderPickupDeadlineWarningInfo(shop: ShopDTO, tab: OrderTab) {
    return tab === OrderTab.PICKUP_DEADLINE_WARNING && pickupDeadlineWarningShopTypes.includes(shop.type);
}

const PickupDeadlineWarningInfo: React.FC<PickupDeadlineWarningInfoProps> = function (props) {
    const { shop, order, tab } = props;

    if (!shouldRenderPickupDeadlineWarningInfo(shop, tab)) {
        return null;
    }

    return (
        <div>
            <ShippingDeadlineCalculator
                shop={shop}
                shippingDeadline={order.shippingDeadline}
                showCountdown={showDeadlineShippingOrderTabs.includes(tab)}
            />
        </div>
    );
};

export default React.memo(PickupDeadlineWarningInfo);
